import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { CURRICULUM_HIGHLIGHTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/curriculum-highlights/")({
  component: () => <DeptContentList cfg={CURRICULUM_HIGHLIGHTS} />,
});
